// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/style.min.css
// module id = KMRC
// module chunks = 1